import { ReportSectionComponentType } from '../types';
import { useReportUpdater } from '../hooks/useReportUpdater';
import EmptySectionWarning from '../components/emptySectionWarning';
import ReportSectionFiles from '../components/reportSectionFiles';
import StepFooter from '../../common/components/stepFooter';

/**
 * Report "Record of advice" step
 */
const RecordOfAdviceStep: ReportSectionComponentType = ({
  sectionName,
  report,
  templateFileUrl,
  onClickBack,
  onClickNext,
  isLoading: isSomethingLoading,
}) => {
  const { addFile, removeFile, isLoading, saveChanges, setPropertyValue, sectionData } =
    useReportUpdater({
      report,
      sectionName,
    });

  const handleClickNext = (): void => {
    saveChanges().then(() => onClickNext());
  };

  if (!sectionData) {
    return <EmptySectionWarning />;
  }

  return (
    <>
      {templateFileUrl && (
        <ReportSectionFiles
          addFile={addFile}
          removeFile={removeFile}
          sectionData={sectionData}
          templateFileUrl={templateFileUrl}
          setPropertyValue={setPropertyValue}
        />
      )}
      <StepFooter
        isLoading={isLoading || isSomethingLoading}
        onClickBack={onClickBack}
        onClickNext={handleClickNext}
      />
    </>
  );
};

export default RecordOfAdviceStep;
